"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidCreditError = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ErrorMessage = require("../../ErrorMessage");

var _useInvalidCreditError = require("./useInvalidCreditError");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes.number.isRequired,
  productType: _propTypes.string.isRequired,
  onEditValue: _propTypes.func.isRequired
} : {};

const InvalidCreditError = ({
  value,
  productType,
  onEditValue
}) => {
  const {
    messages,
    validationType
  } = (0, _useInvalidCreditError.useInvalidCreditError)(value, productType);
  return validationType && (0, _core.jsx)(_ErrorMessage.ErrorMessage, {
    "data-testid": "invalid-credit-error"
  }, (0, _core.jsx)(_ErrorMessage.ErrorTitle, null, messages.title), (0, _core.jsx)(_ErrorMessage.ErrorDescription, null, messages.description), (0, _core.jsx)(_ErrorMessage.ErrorAction, {
    onClick: onEditValue
  }, "Editar valor"));
};

exports.InvalidCreditError = InvalidCreditError;
process.env.NODE_ENV !== "production" ? InvalidCreditError.propTypes = propTypes : void 0;
InvalidCreditError.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InvalidCreditError",
  "props": {
    "value": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    },
    "productType": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "onEditValue": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};